import { makeSelectors } from '@utils/css';

const crossfadeDurationMs = 225;
const container = "_35sc1y64314";
const content = "_35sc1m6e9yv";
const contentWrapper = "_35scntg0aw";
makeSelectors({
  container
});

export { container, content, contentWrapper, crossfadeDurationMs };
import "./_page.input.style.linaria.module.css";
//# sourceMappingURL=_page.input.style.js.map
